import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["page", "location"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import { filterProps } from 'foundations-components/utils/filterProps';
import GoToPaymentsButton from 'growth-payments-core/components/GoToPaymentsButton';
import { useEligibilityBinding } from 'growth-payments-core/eligibility/eligibilityBinding';
import { UnderwritingStatus } from 'growth-payments-core/eligibility/types';
import { jsx as _jsx } from "react/jsx-runtime";
const SETUP_CTA_MESSAGES = {
  SETUP_PAYMENTS_MESSAGE: 'embedPoints.setupCta.setUpPayments',
  CONTINUE_SETUP_MESSAGE: 'embedPoints.setupCta.continueSetup',
  GO_TO_COMMERCE_MESSAGE: 'embedPoints.setupCta.gotoCommerceHome'
};
const buttonMessageRecord = {
  [UnderwritingStatus.IN_KYC]: SETUP_CTA_MESSAGES.CONTINUE_SETUP_MESSAGE,
  [UnderwritingStatus.IN_UNDERWRITING]: SETUP_CTA_MESSAGES.GO_TO_COMMERCE_MESSAGE,
  [UnderwritingStatus.APPROVED]: SETUP_CTA_MESSAGES.GO_TO_COMMERCE_MESSAGE,
  [UnderwritingStatus.REJECTED]: SETUP_CTA_MESSAGES.GO_TO_COMMERCE_MESSAGE
};
const GoToPaymentsButtonWrapper = _ref => {
  let {
      page,
      location
    } = _ref,
    passthroughProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const [eligibility] = useEligibilityBinding();
  const message = eligibility && eligibility.underwritingStatus && buttonMessageRecord[eligibility.underwritingStatus] || SETUP_CTA_MESSAGES.SETUP_PAYMENTS_MESSAGE;
  const {
    domProps,
    tokenProps,
    callbackProps,
    restProps
  } = filterProps(passthroughProps);
  return /*#__PURE__*/_jsx(GoToPaymentsButton, Object.assign({
    page: page,
    location: location
  }, domProps, tokenProps, callbackProps, restProps, {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: message
    })
  }));
};
export default GoToPaymentsButtonWrapper;